"use client"

import { cn } from "@/lib/utils";
import { CSSProperties } from "react";
import { motion } from "framer-motion";

export default function Wave({ style, className, flipX = false, flipY = false, scaleY = 0.25 }: { style?: CSSProperties, className?: string, flipX?: boolean, flipY?: boolean, scaleY?: number }) {
    return (
        <div className={cn("w-full overflow-x-clip", className)}>
            <div
                className={cn("w-full", className)}
            // initial={{
            //     scaleX: 12,
            //     scaleY: 30,
            //     x: flipY ? "-200%" : "200%",
            //     y: flipY ? "-1450%" : "1450%",
            // }}
            // whileInView={{
            //     scaleX: 1,
            //     scaleY: 1,
            //     x: 0,
            //     y: 0,
            // }}
            // viewport={{
            //     once: true,
            //     margin: "0px 0px 60% 0px"
            // }}
            // transition={{
            //     type: "tween",
            //     ease: "easeOut",
            //     duration: 0.5,
            // }}
            >
                <svg
                    width="100%"
                    viewBox="0 0 1512 166"
                    fill="none"
                    version="1.1"
                    id="svg1"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                        ...style,
                        transformOrigin: flipY ? "bottom" : "top",
                        transform: `scaleY(calc(${scaleY} ${flipY ? "" : ""}))
                ${flipY ?
                                "translateY(calc((100% - 0.5vw) * -1)) rotate(180deg)"
                                :
                                "translateY(calc(0.5vw * -1))"
                            }
                ${flipX ? "scaleX(-1)" : ""}`
                    }}
                    className={cn(
                        "max-h-64 z-40 text-defaultAccent",
                        // flipX ?
                        //     "scale-x-[-1]"
                        //     :
                        //     "",
                        flipY ?
                            ``
                            :
                            `sticky top-[4rem]`,
                        className,
                    )}
                    preserveAspectRatio="none"
                >
                    <defs
                        id="defs1" />
                    <mask
                        id="mask0_654_3"
                        maskUnits="userSpaceOnUse"
                        x="-200"
                        y="-205"
                        width="1748"
                        height="469">
                        <path
                            d="m -163.697,-80.9999 c -195.999,-342.0001 405.502,152.5 1710.997,0 l 0.01,267.2829 c 0,0 -473,-174.5001 -882.503,0 -409.5,174.5 -828.502,0 -828.502,0 z"
                            fill="#fff"
                            id="path1" />
                    </mask>
                    <g
                        mask="url(#mask0_654_3)"
                        id="g1"
                        transform="translate(-1,-98)">
                        <rect
                            x="1"
                            y="98"
                            width="1512"
                            height="166"
                            fill="currentColor"
                            id="rect1" />
                    </g>
                </svg>
            </div>
        </div>
    )
}
